import { Directive, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[autosizeIframe]'
})
export class AutosizeIframeDirective implements OnDestroy {
    el;
    previousHeight = 0;
    previousWidth = 0;
    stop = false;
    timer;

    @Output() resize = new EventEmitter();

    constructor(private elem: ElementRef) {
        this.el = this.elem.nativeElement;
        this.run();
    }
    run() {
        if( this.stop ) {
            return;
        }
        this.timer = setTimeout(() => {
            if( this.el.src && this.el.contentWindow.document.body ) {
                let newHeight = this.el.contentWindow.document.body.offsetHeight;
                const parentHeight = this.el.parentElement.offsetHeight + 20;
                newHeight = newHeight < parentHeight ? parentHeight : newHeight;
                const newWidth = this.el.contentWindow.document.body.offsetWidth;
                if( newHeight !== this.previousHeight || newWidth !== this.previousWidth ) {
                    this.el.style.height = newHeight;
                    this.elem.nativeElement.style.height = newHeight + 'px';
                    this.previousHeight = newHeight;
                    this.previousWidth = newWidth;
                    this.resize.emit({
                        height: newHeight,
                        width: newWidth
                    });
                }
            }
            this.run();
        }, 200);
    }
    ngOnDestroy() {
        clearTimeout(this.timer);
        this.stop = true;
    }
}